<template>
  <div>
    <ActionsMenu
      v-if="actions.length"
      :actions="actions"
      :options="{ theme: 'light' }"
      data-cy="batched-actions-context-menu"
      @break-batch="toggleModal"
      @download-batch="handleDownloadBatch"
      @batch-details="handleBatchDetails"
    />
    <Modal
      v-if="modalOpen"
      :width="500"
      :title="`Break Batch #${batchNumber}`"
      submit-btn-text="Break Batch"
      submit-btn-class="btn btn-sm btn-danger ml-auto"
      saving-text="Breaking Batch..."
      :saving="saving"
      @hide-modal="toggleModal"
      @submit="handleSubmit"
    >
      <div>
        <p class="mb-4">
          <strong>You are about to break a batch.</strong>
          <br />
          Once broken, Invoices and Payments included in the batch will be
          returned to the Unbatched Report under the Accounting menu. This
          action cannot be undone.
        </p>
        <p class="mb-4">
          If you have already imported the batch into your accounting software,
          you will need to reconcile these invoices and payments if included in
          a subsequent batch.
        </p>
        <div class="danger-dialog">
          <i class="far fa-exclamation-triangle mr-1"></i>
          This action cannot be undone
        </div>
      </div>
    </Modal>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { EventBus } from "@/lib/event_bus.js";
import { useStore } from "vuex";

import ActionsMenu from "@/components/ActionsMenu.vue";
import Modal from "@/components/Modal.vue";

const store = useStore();
const props = defineProps({
  batchLink: {
    type: String,
    required: true
  },
  batchNumber: {
    type: Number,
    required: true
  },
  breakEligible: {
    type: Boolean,
    required: true
  },
  processor: {
    type: String,
    required: true
  },
  batchDetailsLink: {
    type: String,
    required: true
  }
});

const modalOpen = ref(false);
const saving = ref(false);
const toggleModal = (newValue) => {
  modalOpen.value = newValue !== undefined ? newValue : !modalOpen.value;
};

function handleDownloadBatch() {
  window.open(props.batchLink, "_blank");
}

function handleBatchDetails() {
  window.location.href = props.batchDetailsLink;
}

const getActions = () => {
  let actions;
  if (props.processor == "qbo") {
    actions = [
      {
        label: "Batch Details",
        icon: "far fa-file-circle-info",
        eventName: "batch-details"
      }
    ];
  } else {
    actions = [
      {
        icon: "far fa-download",
        label: "Download Batch",
        eventName: "download-batch",
        disabled: !props.batchLink
      },
      {
        label: "Break Batch",
        icon: "far fa-file-slash",
        eventName: "break-batch",
        disabled: !props.breakEligible
      }
    ];
  }

  return actions;
};

const actions = ref(getActions());

const handleSubmit = async () => {
  saving.value = true;

  try {
    await store.dispatch("destroyBatch", {
      url: props.batchLink
    });

    window.notify.success(`Breaking batch #${props.batchNumber} succeeded!`);
    toggleModal(false);
    EventBus.$emit("refresh-datatable");
  } catch (e) {
    // do nothing
  }

  saving.value = false;
};
</script>

<style lang="scss" scoped>
.danger-dialog {
  // $danger-color: #de0000;
  background-color: rgba(#de0000, 0.2);
  padding: 1rem;
  font-weight: bold;
  text-align: center;
}
</style>
